import { Component } from '@angular/core';
import { MainBtnComponent } from '../main-btn/main-btn.component';

@Component({
  selector: 'app-cover-static-flash',
  imports: [
    // MainBtnComponent
  ],
  templateUrl: './cover-static-flash.component.html',
  styleUrl: './cover-static-flash.component.css'
})
export class CoverStaticFlashComponent {

}
